<!--Provides options to select area-->
<template>
  <div class="col-sm-12 nopads">
    <!--Area selection-->
        <span class="span-title">{{ $t('areas.area') }}</span>
        <div v-if="!multiple" class="nopads">
          <select
            id="area"
            v-model="area"
            class="form-select form-select-sm"
            :disabled="results.length < 1"
          >
              <option :value="null">
                {{ $t('areas.select_area') }}
              </option>
            <option
              v-for="option in results"
              :key="option.id"
              :value="option"
            >
              {{ option.name }}
            </option>
          </select>
        </div>
        <div v-if="multiple" class="nopads pe-2">
          <multiselect
            v-model="selectedAreas"
            class="multiselect_routa"
            :placeholder="$t('areas.select_area')"
            :deselect-label="$t('common.remove_selection')"
            :select-label="$t('common.select')"
            :close-on-select="false"
            :multiple="true"
            label="name"
            track-by="id"
            :searchable="true"
            :internal-search="true"
            :selected-label="$t('common.selected')"
            :options="results"
          >
            <template
              #singleLabel="props"
            >
              <span class="option__desc">
                <span class="option__title">{{ props.option.name }}</span>
              </span>
            </template>
            <template
              #option="props"
            >
              <div class="option__desc">
                <span class="option__title multiselect_detail_block">{{
                  props.option.name
                }}</span>
              </div>
            </template>
            <template #noResult>
              <span>{{ $t('common.not_found') }}</span>
            </template>
            <template #noOptions>
              <span>{{ $t('common.no_results') }}</span>
            </template>
          </multiselect>
        </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {areaHelper} from '../mixins/AreaMixin'

export default {
    name: 'AreaFilter',
    mixins: [restApi, areaHelper],
    props: {
        noGeom: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        areas: {
            type: Array,
            default: null
        },
        equipment: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            companies: [],
            results: [],
            area: null,
            selectedAreas: []
        }
    },
    watch: {
        area: function () {
            this.$emit('areaSet', this.area)
        },
        selectedAreas: function () {
            this.$emit('areasSet', this.selectedAreas)
        },
        areas: function() {
            this.results = this.areas
        }
    },
    mounted: function () {
        if (this.areas) {
            this.results = this.areas
        } else {
            this.fetchAreas()
        }
    },
    methods: {
        resetData: function () {
            this.company = null
            this.area = null
            this.selectedAreas = []
        },

        fetchAreas: function () {
            this.loading = true
            let params =  {
                equipment: 0
            }
            if (this.noGeom) {
                params.no_geom = 1
            }
            this.restFetchParams(this.areaUrl, params, this.handleAreaResults)
        },

        handleAreaResults: function (response) {
            this.loading = false
            this.results = response.data
            this.initArea()
        },
        initArea: function () {
            if (this.equipment && this.equipment.id !== null) {
                let equipmentArea = this.results.find(area => area.id === this.equipment.area.id)
                if (equipmentArea !== undefined) {
                    if(this.multiple) {
                        this.selectedAreas.push(equipmentArea)
                    } else {
                        this.area = equipmentArea
                    }
                }
            }
        }
    }
}
</script>
